import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const CircleCheckIcon = createSvgIcon(
  <>
    <title>circle check</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <polyline
        data-color="color-2"
        fill="none"
        points=" 9,17 13,21 23,11 "
        strokeMiterlimit="10"
      />{' '}
      <circle
        cx="16"
        cy="16"
        fill="none"
        r="15"
        stroke="#222222"
        strokeMiterlimit="10"
      />
    </g>
  </>
)
